import Vue from 'vue';
import Vuex from 'vuex';
import createMutationsSharer from 'vuex-shared-mutations';

import app from '@motionelements/core/src/store/modules/app.js'; // migrate site to app
// import browser from '@motionelements/core/src/store/modules/browser.js';
import user from '@motionelements/core/src/store/modules/user.js';
import route from '@motionelements/core/src/store/modules/route.js';
import cart from '@motionelements/core/src/store/modules/cart.js';
import notification from '@motionelements/core/src/store/modules/notification.js';
import modal from '@motionelements/core/src/store/modules/modal.js';
import cookie from '@motionelements/core/src/store/modules/cookie.js';
import blocker from '@motionelements/core/src/store/modules/blocker.js';
import favorites from '@motionelements/core/src/store/modules/favorites.js'; // display favorites
import searchBox from '@motionelements/core/src/store/modules/search-box.js'; // search history support move to search box
import experiment from '@motionelements/core/src/store/modules/experiment.js';
import audioPlayer from '@motionelements/core/src/store/modules/audioPlayer.js';
import videoPlayer from '@motionelements/core/src/store/modules/videoPlayer.js';
import paymentMethods from '@motionelements/core/src/store/modules/payment-methods.js';
import aiTools from '@motionelements/core/src/store/modules/ai-tools.js';
import productRecommendationAudio from '@motionelements/core/src/store/modules/productRecommendationAudio';
import vuexSharedMutations from '@motionelements/core/src/helpers/vuexSharedMutations.js';
import apiValidationErrors from '@motionelements/core/src/store/modules/api-validation-errors.js';

// import { persistCurrency } from 'me-frontend-page-no-prerender/src/store/persists';
import {
  persistAccount,
  persistAudioPlayer,
  persistCart,
  // persistCurrency,
  persistExperiment,
  persistFavorites,
  persistLibrary,
  persistNavbar,
  persistSearch,
  persistSearchBox,
} from '@/store/persists';

import product from '@/store/modules/product.js';
import payment from '@/store/modules/payment.js';

import search from '@/store/modules/search.js';
import library from '@/store/modules/library/library.js';
import followedMembers from '@/store/modules/library/followedMembers.js';
import converting from '@/store/modules/converting/converting.js';
import credits from '@/store/modules/credits.js';
import subscription from '@/store/modules/subscription.js';
import faqs from '@/store/modules/faqs.js';
// search-infinite-scroll
import searchInfiniteScroll from '@/store/modules/search-infinite-scroll.js';
import browser from '@/store/modules/browser.js';
import audioPlayer2025 from '@/store/modules/audioPlayer2025.js';
import overlay from '@/store/modules/overlay.js';

const isProduction = process.env.VUE_APP_ENV === 'production';

let mutationPredicates = [
  // search
  'search/setPreferences',
  'search/setPerPage',
  // searchBox
  'searchBox/addHistory',
  'searchBox/deleteItem',
  'searchBox/deleteAll',
  // library
  'library/setPreferences',
  // player
  'audioPlayer/setSoundProgress',
  ...vuexSharedMutations,
];

if (!isProduction) {
  mutationPredicates = [...mutationPredicates, ...[
    // additional for staging / dev
    'user/setJwtId',
    'user/setMember',
    'user/setMemberCredits',
    'user/setLanguage',
    'user/setCurrencies',
  ]];
}

// eslint-disable-next-line no-unused-vars
const mutationSharer = createMutationsSharer({
  predicate: mutationPredicates,
});

// production plugins
let plugins = [
  mutationSharer,
  persistAudioPlayer.plugin,
  persistCart.plugin,
  persistExperiment.plugin,
  persistFavorites.plugin,
  persistLibrary.plugin,
  persistNavbar.plugin,
  persistSearch.plugin,
  persistSearchBox.plugin,
];

if (!isProduction) {
  plugins = [...plugins, ...[
    // additional plugins for staging / dev
    persistAccount.plugin,
    // persistCurrency.plugin,
  ]];
}

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    // CORE modules
    app,
    browser,
    cookie,
    experiment,
    modal,
    notification,
    user,
    faqs,
    apiValidationErrors,
    aiTools,

    // OTHER modules
    blocker,
    route,
    cart,
    audioPlayer,
    videoPlayer,
    searchBox,
    // member,
    product,
    search,
    payment,
    favorites,
    library,
    followedMembers,
    converting,
    credits,
    subscription,
    paymentMethods,
    productRecommendationAudio,
    //
    searchInfiniteScroll,
    //
    audioPlayer2025,
    overlay,
  },
  plugins: plugins,
});
